/**
 * Drawing parser — proxies through the paneliq /vision/interpret-drawing
 * endpoint so the team's Anthropic key never lands in the browser bundle.
 *
 * Returns the normalized { loads, meta, raw } shape that App.jsx expects.
 */
import { apiBaseUrl, getToken, clearToken } from './auth.js';

/**
 * @param {File} file - The raw File from a <input type=file>. Image or PDF.
 * @returns {Promise<{loads:any[], meta:object, raw:string}>}
 */
export async function interpretDrawing(file) {
  const token = getToken();
  if (!token) {
    throw new Error('Not signed in. Please sign in again.');
  }
  if (!file) {
    throw new Error('No file provided.');
  }

  const form = new FormData();
  // Pass the File directly — preserves mime type so the server can branch on
  // PDF vs image without us hand-rolling content sniffing.
  form.append('image', file, file.name || 'drawing');

  const response = await fetch(apiBaseUrl() + '/vision/interpret-drawing', {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: form,
  });

  if (response.status === 401) {
    clearToken();
    throw new Error('Session expired. Please sign in again.');
  }

  let data = null;
  try { data = await response.json(); } catch { /* leave null */ }

  if (!response.ok) {
    const detail = (data && data.detail) || `Vision API error ${response.status}`;
    throw new Error(detail);
  }

  // Server returns { loads, meta, raw } already normalized — pass through.
  return data;
}
